export function hex2ustring(input) {
    const hexes = input.match(/.{1,4}/g) || [];
    let back = "";
    for (let i = 0; i < hexes.length; i++) {
        back += String.fromCharCode(parseInt(hexes[i], 16));
    }
    return back;
}
export function ustring2hex(input) {
    let hex, i;
    let result = "";
    for (i = 0; i < input.length; i++) {
        hex = input.charCodeAt(i).toString(16);
        result += ("000" + hex).slice(-4);
    }
    return result;
}
// only valid for all char is ascii
export function shorthex2ascii(input) {
    const hexes = input.match(/.{1,2}/g) || [];
    let back = "";
    for (let i = 0; i < hexes.length; i++) {
        back += String.fromCharCode(parseInt(hexes[i], 16));
    }
    return back;
}
// only valid for all char is ascii
export function ascii2shorthex(input) {
    let hex, i;
    let result = "";
    for (i = 0; i < input.length; i++) {
        hex = input.charCodeAt(i).toString(16);
        result += hex;
    }
    return result;
}
